import { ColorScheme, THEME_COLORS, ThemeColor } from '@/app/shared/models/theme.model'
import { AppService } from '@/app/shared/services/app.service'
import { FILTER_PERSISTENCE_PAGES, UserPreferencesService } from '@/app/shared/services/user-preferences.service'
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'

@Component({
  selector: 'app-settings-dialog',
  templateUrl: './settings-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsDialog {
  // Services
  private readonly app = inject(AppService)
  private readonly prefs = inject(UserPreferencesService)

  // State
  protected readonly themeColor = this.app.themeColor
  protected readonly themeColors = THEME_COLORS
  protected readonly colorScheme = this.app.colorScheme
  protected readonly schemeModes: { value: ColorScheme; label: string; icon: string }[] = [
    { value: 'system', label: 'Système', icon: 'brightness_auto' },
    { value: 'light', label: 'Clair', icon: 'light_mode' },
    { value: 'dark', label: 'Sombre', icon: 'dark_mode' },
  ]
  protected readonly filterPages = FILTER_PERSISTENCE_PAGES
  protected readonly activeTab = signal<'theme' | 'filters'>('theme')

  // Handlers
  selectColor(color: ThemeColor): void {
    this.app.setThemeColor(color)
  }

  selectScheme(scheme: ColorScheme): void {
    this.app.setColorScheme(scheme)
  }

  isFilterPersisted(pageKey: string): boolean {
    return this.prefs.isFilterPersistenceEnabled(pageKey)
  }

  toggleFilterPersistence(pageKey: string): void {
    this.prefs.setFilterPersistence(pageKey, !this.prefs.isFilterPersistenceEnabled(pageKey))
  }

  close(): void {
    this.app.closeDialog()
  }
}
